import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiBell, FiSearch, FiDatabase, FiLogOut } from 'react-icons/fi';

const Topbar = ({ toggleSidebar, admin, backendStatus, onLogout }) => {
  const pocketBaseLive = backendStatus?.pocketbase === 'connected';
  const runtimeLive = backendStatus?.gateway === 'operational';

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sticky top-0 z-10">
      <div className="flex items-center gap-4">
        <button onClick={toggleSidebar} className="md:hidden p-2 -ml-2 text-slate-500 hover:bg-slate-100 rounded-md">
          <SafeIcon icon={FiMenu} className="text-xl" />
        </button>
        <div className="hidden sm:block">
          <h1 className="text-lg font-semibold text-slate-800 leading-tight">BPA Central Email Hub</h1>
          <p className="text-xs text-slate-500">Secure app email routing, queued delivery and monitoring</p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className={`px-2.5 py-1 text-[10px] font-bold border rounded-full flex items-center gap-1.5 shadow-sm ${runtimeLive ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : pocketBaseLive ? 'bg-amber-50 text-amber-800 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`}>
          <SafeIcon icon={FiDatabase} className={runtimeLive ? 'text-emerald-500' : pocketBaseLive ? 'text-amber-500' : 'text-red-500'} />
          {runtimeLive ? 'MAIL API READY' : pocketBaseLive ? 'PB LIVE · HOOK OFF' : 'POCKETBASE OFFLINE'}
        </div>

        <div className="hidden md:flex items-center relative">
          <SafeIcon icon={FiSearch} className="absolute left-3 text-slate-400" />
          <input
            type="text"
            placeholder="Search apps, keys..."
            className="pl-9 pr-4 py-1.5 bg-slate-100 border-transparent rounded-md text-sm focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all outline-none w-48 lg:w-64"
          />
        </div>

        <button className="relative p-2 text-slate-500 hover:bg-slate-100 rounded-full transition-colors" title="Notifications">
          <SafeIcon icon={FiBell} className="text-xl" />
        </button>

        <div className="hidden sm:flex items-center gap-2 pl-3 border-l border-slate-200">
          <div className="w-8 h-8 rounded-full bg-blue-100 border border-blue-200 flex items-center justify-center text-blue-700 font-semibold text-sm">
            {(admin?.displayName || 'AD').split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase()}
          </div>
          <button
            onClick={onLogout}
            className="p-2 text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Logout"
          >
            <SafeIcon icon={FiLogOut} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Topbar;